__webpack_require__.p = "/fyvaseller_frontend/app/";